<template>
    <div>
        <b-button
            variant="danger"
            @click="logout()"
        >
            Logout
        </b-button>
        <h1>Welcome, {{ displayName }}!</h1>
        <h2>Your saved resources</h2>
        <div v-for="(topic, y) in savedResourceKeys"
            :key="y">

        </div>

        <div class="content">
            <resource-cards
                :topicContent="allContent"
            >
            </resource-cards>
        </div>

    </div>
</template>

<script>
/* eslint-disable no-unused-vars */
/* eslint-disable no-restricted-syntax */

import firebase from 'firebase';
import Multiselect from 'vue-multiselect';
import Vue from 'vue';
// eslint-disable-next-line import/no-unresolved
import ResourceCards from '@/components/ResourceCards.vue';

// eslint-disable-next-line import/no-unresolved
import { useRemoteServer } from '@/variables';
// register globally
Vue.component('multiselect', Multiselect);

export default {

    components: {
        // Multiselect,
        ResourceCards,
    },
    data() {
        return {
            uid: '',
            saved: '',
            displayName: '',
            formSubmitted: false,
            loginFailed: false,
            errorMessage: '',
            form: {
                email: '',
                password: '',
            },
            useRemoteServer,
            dbUser: '',
            savedResourceKeys: [],
            topicContent: '',
            allContent: [],
        };
    },
    methods: {
        logout() {
            firebase
                .auth()
                .signOut()
                .then(() => {
                    console.log('Successfully logged out');
                    this.$router.push('/');
                })
                .catch((error) => {
                    console.log(error.message);
                    this.$router.push('/');
                });
        },

        async loadSavedResources() {
            console.log('saved resources 2 ', this.savedResourceKeys);
            const SERVER_URL = this.useRemoteServer ? 'https://cryptic-shelf-69256.herokuapp.com/' : '';
            const url = `${SERVER_URL}api/get_all_resources`;
            const response = await fetch(url);
            const serverData = await response.json();
            // console.log(this.savedResourceKeys);
            this.allContent = serverData.content.map((thing) => {
                const tempArray = thing.resources.filter((resource) => {
                    // eslint-disable-next-line no-restricted-syntax
                    for (const [key, v] of Object.entries(this.savedResourceKeys)) {
                        // eslint-disable-next-line eqeqeq
                        // console.log('eslint temp fix ', key);
                        if (resource.id === v) {
                            return true;
                        }
                    }
                    return false;
                });

                return {
                    resources: tempArray,
                    title: thing.title,
                };
            });
        },

    },

    async mounted() {
        const onAuthStateChangedPromise = new Promise((resolve, reject) => {
            console.log('is this being hit');
            firebase.auth().onAuthStateChanged((user) => {
                //   store.commit(user !== null ? 'LOGIN' : 'LOGOUT', user)
                resolve(user);
            }, (err) => {
                reject(err);
            });
        });
        const onAuthStateInit = () => onAuthStateChangedPromise;
        await onAuthStateInit();

        const user = firebase.auth().currentUser;
        console.log('this is the mounted user ', user);
        this.displayName = user.displayName;
        console.log('this is the name ', this.displayName);
        this.uid = user.uid;
        console.log('uid ', this.uid);
        firebase.database().ref(`/data/users/${this.uid}`).once('value').then((snapshot) => {
            this.savedResourceKeys = (snapshot.val().saved);
            console.log('saved resources 1 ', this.savedResourceKeys);
            this.loadSavedResources();
        });
    },
};
</script>

<style scoped>

button {
    float: right;
    margin-right: 2%;
}

.login {
    width: 80%;
    margin: auto;
    background-color: white;
    padding: 2%;
}

.submit-buttons {
    margin: 10px;
}

h5 {
    font-weight: bold;
    color: black;
}

#login-error {
   font-weight: bold;
   color: red;
}

.content {
    margin-right: 5%;
    margin-left: 5%;
}

</style>
